import { render } from "./VOfflineBooking.vue?vue&type=template&id=3c48223e"
import script from "./VOfflineBooking.vue?vue&type=script&lang=js"
export * from "./VOfflineBooking.vue?vue&type=script&lang=js"

import exportComponent from "/apps/releases/202604221556/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/platform/components/offline-booking/VOfflineBooking.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3c48223e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3c48223e', __exports__)) {
    api.reload('3c48223e', __exports__)
  }
  
  module.hot.accept("./VOfflineBooking.vue?vue&type=template&id=3c48223e", () => {
    api.rerender('3c48223e', render)
  })

}


export default __exports__